import React, { Component } from "react";
//import {throttle} from "lodash";
import { Button } from "@learningblocks/storybook-components"

import "./style.scss";

// import {
//   start,
//   drag,
//   end,
//   setDragImage,
//   getTarget,
//   getTransform
// } from "./DragFunctions"

class CyclingStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 0
    };

    this.dragarea = React.createRef();
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  setMaxHeight = () => {
    let height = (this.dragarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    })
  }

  goToEditView = (e, id) => {
    this.props.setEditConnection({
      id: this.props.id,
      editConnection: id
    })
    this.props.setInnerSection({
      id: this.props.id,
      innerSection: "STEP_EDIT"
    })
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }

  render() {
    return (
      <div className="cycling-step" style={{display: "flex", flexDirection: "column"}}
           onClick={(e)=>this.goToEditView(e, this.props.props.id)}>
        <div className="step-header">
          <div className="step-blank">
            <span>{this.props.props.id}</span>
            <div>
              <span>Repeat: </span><span>{this.props.props.repeat}</span>
            </div>
          </div>
          <div className="step-sublabels">
            <div className="step-label">
              (A) Denaturation
            </div>
            <div className="step-label">
              (B) Annealing
            </div>
            <div className="step-label">
              (C) Elongation
            </div>
          </div>
        </div>
        <div className="step-substeps">
          {this.props.props.subSteps.map(step => (
            <div>
              <div
                className="step-drag-area"
                ref={this.dragarea}
                >
                <div
                  className="drag-item"
                  style={{ transform: "translate3d(0px, "+(this.state.maxHeight - this.convertTempToOffset(step.temp))+"px, 0px) rotateZ(0deg)" }}
                >
                  <span>{step.temp + "°C"}</span>
                  <span>{(step.duration==="100:40:39")?"Infinity":step.duration}</span>
                </div>
              </div>
              <div className="step-footer">
                <p>{(step.duration==="100:40:39")?"Infinity":step.duration}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }
}

class ConstantStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 0
    };

    this.dragarea = React.createRef();
  }

  setMaxHeight = () => {
    let height = (this.dragarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    })
  }

  goToEditView = (e, id) => {
    this.props.setEditConnection({
      id: this.props.id,
      editConnection: id
    })
    this.props.setInnerSection({
      id: this.props.id,
      innerSection: "STEP_EDIT"
    })
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }

  render() {
    return (
      <div className="constant-step" style={{display: "flex", flexDirection: "column"}}
           onClick={(e)=>this.goToEditView(e, this.props.props.id)}>
        <div className="step-header">
          <div className="step-blank"></div>
          <div className="step-label">
            {this.props.props.id}
          </div>
        </div>
        <div
          className="step-drag-area"
          ref={this.dragarea}
          >
          <div
            className="drag-item"
            style={{ transform: "translate3d(0px, "+(this.state.maxHeight - this.convertTempToOffset(this.props.props.temp))+"px, 0px) rotateZ(0deg)" }}
          >
            <span>{this.props.props.temp + "°C"}</span>
            <span>{this.props.props.duration}</span>
          </div>
        </div>
        <div className="step-footer">
          <p>{this.props.props.duration}</p>
        </div>
      </div>
    )
  }
}

class FinalStep extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 0
    };

    this.dragarea = React.createRef();
  }

  setMaxHeight = () => {
    let height = (this.dragarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    })
  }

  goToEditView = (e, id) => {
    this.props.setEditConnection({
      id: this.props.id,
      editConnection: id
    })
    this.props.setInnerSection({
      id: this.props.id,
      innerSection: "STEP_EDIT"
    })
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }

  render() {
    return (
      <div className="final-step" style={{display: "flex", flexDirection: "column"}}
           onClick={(e)=>this.goToEditView(e, this.props.props.id)}>
        <div className="step-header">
          <div className="step-blank"></div>
          <div className="step-label">
            {this.props.props.id}
          </div>
        </div>
        <div
          className="step-drag-area"
          ref={this.dragarea}
          >
          <div
            className="drag-item"
            style={{ transform: "translate3d(0px, "+(this.state.maxHeight - this.convertTempToOffset(this.props.props.temp))+"px, 0px) rotateZ(0deg)" }}
          >
            <span>{this.props.props.temp + "°C"}</span>
            <span>{this.props.props.duration}</span>
          </div>
        </div>
        <div className="step-footer">
          <p>{this.props.props.duration}</p>
        </div>
      </div>
    )
  }
}

class RenderLine extends Component {

  constructor(props) {
    super(props);

    this.state = {
      maxHeight: 0,
      lineOffsets: []
    };

    this.chartarea = React.createRef();
  }

  setMaxHeight = () => {
    let height = (this.chartarea.current.getBoundingClientRect().height - 52)

    this.setState({
      maxHeight: height
    }, ()=>{

      this.setState({
        lineOffsets: this.props.sequence.flatMap(step => {
          if(step.type === "constant"){
            return (this.state.maxHeight - this.convertTempToOffset(step.temp))
          }
          if(step.type === "cycling"){
            return step.subSteps.map(subStep => {
              return (this.state.maxHeight - this.convertTempToOffset(subStep.temp))
            })
          }
          if(step.type === "final"){
            return (this.state.maxHeight - this.convertTempToOffset(step.temp))
          }
        })
      })
    })
  }

  convertTempToOffset = (temp) => {

    let percentage = temp / 95;
    return (this.state.maxHeight * (percentage));
  }

  componentDidMount() {
    // Resize the scene and attach the resize method to the window resize event
    this.setMaxHeight()
    window.addEventListener("resize", this.setMaxHeight);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.setMaxHeight);
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.props.sequence !== prevProps.sequence){
      this.setMaxHeight()
    }
  }

  render() {
    return (
      <div className="line-plot" style={{
        display: "flex",
        flexDirection: "column",
        position: "absolute",
        height: "calc(100% - 112px)",
        marginTop: "76px",
        pointerEvents: "none"
      }}>
        <div
          className="step-line"
          ref={this.chartarea}
          style={{
            display: "flex",
            flexDirection: "row",
            height: "100%"
          }}
          >
          {
            this.state.lineOffsets.map((offset, index)=>(
              <div style={{
                width: "150.5px",
                position: "relative"
              }}>
                <div
                  style={{
                    transform: "translate3d(0px, "+offset+"px, 0px) rotateZ(0deg)",
                    width: "calc(100% - 16px)",
                    height: "1px",
                    background: "#003E6B",
                    marginTop: "27px",
                    marginLeft: "8px"
                  }}
                ></div>
                {(index !== (this.state.lineOffsets.length - 1))?(
                  <div
                    style={{
                      position: "absolute",
                      transform: "translate3d(0px, "+offset+"px, 0px) rotate("+(-Math.atan((offset - this.state.lineOffsets[index + 1]) / 16) * (180 / Math.PI))+"deg)",
                      width: Math.sqrt(Math.pow((offset - this.state.lineOffsets[index + 1]), 2) + Math.pow(16, 2))+"px",
                      height: "1px",
                      transformOrigin: "top left",
                      background: "#003E6B",
                      marginLeft: "calc(100% - 8px)",
                      marginTop: "-1px"
                    }}
                  ></div>
                ):null}
              </div>
            ))
          }
        </div>
      </div>
    )
  }
}

export class ThermocyclerTable extends Component {
  render() {
    return (
      <div className="thermocycler-table" style={{display: "flex", flexDirection: "row"}}>
        {
          (this.props.sequence.length === 0)?(
            <div className="empty-sequence">
              <p>You don't have any steps yet.</p>
              <Button onClick={()=>this.props.insert()}>Insert step</Button>
            </div>
          ):
            this.props.sequence.map(step => {
              if(step.type === "constant"){
                return <ConstantStep
                          props={step}
                          sequence={this.props.sequence}
                          updateSequence={this.props.updateSequence}
                          setInnerSection={this.props.setInnerSection}
                          setEditConnection={this.props.setEditConnection}
                        />
              }
              if(step.type === "cycling"){
                return <CyclingStep
                          props={step}
                          sequence={this.props.sequence}
                          updateSequence={this.props.updateSequence}
                          setInnerSection={this.props.setInnerSection}
                          setEditConnection={this.props.setEditConnection}
                        />
              }
              if(step.type === "final"){
                return <FinalStep
                          props={step}
                          sequence={this.props.sequence}
                          updateSequence={this.props.updateSequence}
                          setInnerSection={this.props.setInnerSection}
                          setEditConnection={this.props.setEditConnection}
                        />
              }
              return null
            })
        }
        <RenderLine sequence={this.props.sequence} />
      </div>
    )
  }
}
